import React, { useRef } from 'react';
import classes from "./MenuButton.css";
import { MenuOutlined } from '@material-ui/icons';
import { IconButton } from "@material-ui/core";
const MenuButton = (props) => {
    let customStyle = {};
    if (props.style) {
        customStyle = props.style;
    }


    return (<div className={classes.MenuButton} style={{ ...customStyle }}>
        <IconButton className={classes.butt} onClick={() => { }} aria-label="Menu">
            <MenuOutlined />
        </IconButton>

    </div>);
}

export default MenuButton;